module.exports = __webpack_public_path__ + "static/img/declaration-right.697a6ec8.svg";